import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api";



class Footer extends Component {
  state = {
    unidade:[]
}

async componentDidMount(){
    const response = await api.post("/unidades/showsite", {id:localStorage.getItem('idunidade')});
    this.setState({ unidade: response.data
     });

  }



  render() {
    return (
      <React.Fragment>

<footer class="page-footer font-small pt-4">

 
  <div class="container text-center text-md-left">

  {/* Grid Row */}
    <div class="row">

      {/* Grid Colum */}
      <div class="col-md-6 mt-md-0 mt-3 ">

     
        <h5 class="text-uppercase">FACULDADE OLGA METTIG</h5>
        <p>Primeira instituição de ensino superior a formar pedagogos no Norte/Nordeste.</p>
        <p>Local: {this.state.unidade.endereco}
      </p>

      </div>
      {/* Grid Colum */}

      <hr class="clearfix w-100 d-md-none pb-3" />

        {/* Grid Colum */}
   
{/* Grid Colum */}
      <div class="col-md-3 mb-md-0 mb-3">

        
<h5 class="text-uppercase">Portais</h5>

<ul class="list-unstyled">
  <li>
    <a href="/user/login">Área Financeira</a>
  </li>
  

  
</ul>

</div>
{/* Grid Colum */}


       {/* Grid Colum */}
      <div class="col-md-3 mb-md-0 mb-3">

        
        <h5 class="text-uppercase">Acessos</h5>

        <ul class="list-unstyled">
          <li>
            <a href="pos-graduacao">Pos Graduação</a>
          </li>
          <li>
            <a href="#!">Institucional</a>
          </li>
          <li>
            <a href="contato">Fale Conosco</a>
          </li>
        </ul>

      </div>
      {/* Grid Colum */}

    </div>

    {/* Grid row */}

  </div>
   {/* Footer Links */}

   {/* Copyright */}
  <div class="footer-copyright text-center py-3">© {new Date().getFullYear()} Copyright:
    <a href="/"> FACULDADE OLGA METTIG</a>
  </div>
  {/* Copyright */}

</footer>
{/* Footer */}



      </React.Fragment>
       
    );
  }
}

export default withRouter(Footer);


// WEBPACK FOOTER //
// ./src/pages/content/footer.js